import React from 'react';
import styled from 'styled-components';
import logoCE from 'img/CE_UCH_BYN.png';
import { Link } from 'react-router-dom';
import { FECHA_ACTUALIZACION } from 'utils/constants';

const FooterMain = styled.footer`
  background: #ffffff;
  border-top: 1px solid #dbe3ee;
  color: #17345c;
  width: 100%;
`;

const Inner = styled.div`
  display: grid;
  gap: 34px;
  grid-template-columns: minmax(260px, 1.35fr) repeat(3, minmax(150px, 0.7fr));
  margin: 0 auto;
  max-width: 1450px;
  padding: 28px 20px 22px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
    gap: 22px;
  }
`;

const Brand = styled.div`
  max-width: 390px;
`;

const BrandTitle = styled.h3`
  color: #102f5f;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.25;
  margin: 0 0 12px;
`;

const BrandText = styled.p`
  color: #516887;
  font-size: 13px;
  line-height: 1.45;
  margin: 0 0 14px;
`;

const Logo = styled.img`
  display: block;
  width: 104px;
`;

const Column = styled.div`
  h4 {
    color: #7189ad;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.05em;
    margin: 0 0 12px;
    text-transform: uppercase;
  }

  a {
    color: #17345c;
    display: block;
    font-size: 14px;
    line-height: 1.35;
    margin-bottom: 8px;
    text-decoration: none;
  }

  a:hover {
    color: #18578f;
    text-decoration: underline;
  }
`;

const BottomBar = styled.div`
  background: #eef2f7;
  border-top: 1px solid #dbe3ee;
`;

const BottomInner = styled.div`
  color: #516887;
  font-size: 12px;
  margin: 0 auto;
  max-width: 1450px;
  padding: 10px 20px;
`;

/**
 * Footer.js
 * Muestra los componentes en el pie de página.
 */
const Footer = () => (
  <FooterMain>
    <Inner>
      <Brand>
        <BrandTitle>
          Clúster de simulación de escenarios de mitigación de cambio climático
        </BrandTitle>
        <BrandText>
          Plataforma interactiva del Centro de Energía para explorar proyecciones e instrumentos de mitigación.
        </BrandText>
        <Logo src={logoCE} alt="Logo Centro de Energía" />
      </Brand>
      <Column>
        <h4>Contenido</h4>
        <Link to="/acercade">Modelo de Proyección PMR</Link>
        <Link to="/">Simulación de escenarios</Link>
      </Column>
      <Column>
        <h4>Iniciativas</h4>
        <a href="http://www.diplomacambioclimatico.cl/" target="_blank" rel="noopener noreferrer">
          Diplomado Cambio Climático
        </a>
        <a href="https://observatoriocarbononeutral.cl/#/" target="_blank" rel="noopener noreferrer">
          Observatorio Carbono Neutralidad
        </a>

      </Column>
      <Column>
        <h4>Contacto</h4>
        <a href="http://centroenergia.cl/contacto/" target="_blank" rel="noopener noreferrer">
          Centro de Energía
        </a>
      </Column>
    </Inner>
    <BottomBar>
      <BottomInner>
        Fecha de última actualización: {FECHA_ACTUALIZACION}.
      </BottomInner>
    </BottomBar>
  </FooterMain>
);

export default Footer;
